import React from "react";
import { View } from "react-native";

export const FlexContainer = ({ children }: { children?: React.ReactNode }): JSX.Element => {
    return <View style={{ flex: 1 }}>{children}</View>;
};
